import { lazy, useEffect } from "react";
import "./index.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, Result } from "antd";
import Login from "./pages/Login";
import { PrivateRoute } from "./components/PrivateRout";
import { getAppIsInitialize } from "./redux/selectors";
import { appInitialize } from "./redux/actions";
import { useAppDispatch } from "./redux/store/hooks";
import Main from "./pages/Main";
import Factory from "./pages/Factory";
import Logout from "./components/Logout";

export const App = () => {
  const isInitialize = useSelector(getAppIsInitialize);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isInitialize) {
      dispatch(appInitialize());
    }
  }, [isInitialize]);

  const NotFound = () => {
    return (
      <Result
        status="404"
        title="404"
        subTitle="Такой страницы не существует"
        extra={
          <a href="/main">
            <Button type="primary">На главную</Button>
          </a>
        }
      />
    );
  };

  return (
    <Router>
      {window.location.pathname != "/" && (
        <div className="top-menu">
          <a href="/main">
            <h2>ОТКЛЮЧЕНИЕ ИНТЕРНЕТА</h2>
          </a>
          <Logout />
        </div>
      )}
      <div>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<PrivateRoute />}>
            <Route path="/main" element={<Main />} />
            <Route path="/factory/:Id" element={<Factory />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <p className="footer">© 2025 ООО "Glassen-IT". Все права защищены.</p>
    </Router>
  );
};
